import React, { useState } from 'react';
import { Card, ListGroup, Accordion, Stack, Badge, Button } from 'react-bootstrap';
import { useAccordionButton } from 'react-bootstrap/AccordionButton';
import {TotalSpend} from './TotalSpend'
import '../Pages.css';

const CustomToggle = ({ children, eventKey }) => {
  const decoratedOnClick = useAccordionButton(eventKey);

  return (
    <Card.Header onClick={decoratedOnClick} style={{ cursor: 'pointer' }}>
      {children}
    </Card.Header>
  );
};

export const CompanyCard = ({ company, eventKey, loading, editCompany, totalSpend, openReport, viewActivity }) => {
  const [showTotalSpendModal, setTotalSpendModal] = useState(false);
  const Mailto = ({ email, children }) => {
    return <a className="mailto-link" href={`mailto:${email}`}>{children}</a>;
  };

  const Telto = ({ phone, children }) => {
    return <a className="telto-link" href={`telto:${phone}`}>{children}</a>;
  };

  let USDollar = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  const formatDollar = (n) => {
    if (n) return USDollar.format(n);
    return USDollar.format(0);
  };

  const getSpendingTrendColor = (ts) => {
    if (ts) {
      if (ts.LYTD > ts.YTD) return 'spending-down';
      if (ts.LYTD < ts.YTD) return 'spending-up';
      return 'spending-netrual';
    } else {
      return 'spending-netrual';
    }
  };

  const openTotalSpend = (e) => {
    e.stopPropagation();
    setTotalSpendModal(true);
  }

  const closeTotalSpend = () => {
    setTotalSpendModal(false)
  }

  const isProduction = process.env.NODE_ENV === 'production';

  return (
    <>
    <Accordion defaultActiveKey="0">
      <Card>
        <CustomToggle eventKey={eventKey}>
          <Card.Title>
            <div className='company-title-grid'>
              <div className='company-title-group-1'>
                {company.CustomerDisplayName}
              </div>
              <div className='company-title-group-2'>
                <Stack direction="verticle" gap={2}>
                  <Badge bg="secondary">{company.AccountType ? 'Sales Rep: ' : ''}{company.AccountType}</Badge>
                  <Badge bg="secondary">{company.AccountManager ? 'AM: ' : ''}{company.AccountManager}</Badge>
                </Stack>
              </div>
              {company.Prospect ?
                (company.IsAssociated ?
                  <Button
                    variant="warning"
                    disabled={loading}
                    style={{ borderRadius: "10px" }}
                    onClick={(e) => editCompany(e, company)}
                    className='m-2'>
                    <span className="me-2">
                      <i className="bi bi-pencil"></i>
                    </span>
                    Edit
                  </Button>
                  : null)
                :
                <div className='company-title-group-3 company-spend-badge'>
                  <Stack direction="horizontal" gap={2}>
                    <Badge bg="secondary" className={getSpendingTrendColor(totalSpend)}>LYTD: {formatDollar(totalSpend.LYTD)}</Badge>
                    <Badge bg="secondary" className={getSpendingTrendColor(totalSpend)}>YTD: {formatDollar(totalSpend.YTD)}</Badge>
                    <Badge bg="secondary">LTM: {formatDollar(totalSpend.L12M)}</Badge>
                    <Badge bg="secondary">LCY: {formatDollar(totalSpend.LCY)}</Badge>
                    <button
                      className="totalSpend-button"
                      onClick={(e)=>openTotalSpend(e)}
                    >
                      More...
                    </button>
                  </Stack>
                </div>
              }

              <div className='company-title-group-4'>
                <Button
                  variant="success"
                  disabled={loading}
                  style={{ borderRadius: "10px" }}
                  onClick={(e) => viewActivity(e, company)}
                  className='m-2 edit-button'>
                  <span className="me-2">
                    <i className="bi bi-search"></i>
                  </span>
                  View Activities
                </Button>
              </div>

            </div>
          </Card.Title>
        </CustomToggle>
        <Accordion.Collapse eventKey={eventKey}>
          <Card.Body>
            <div className='card-grid'>
              <div className='card-item-1'>
                <ListGroup className="list-group-flush">
                  <ListGroup.Item><div className='text-row'><div className='card-bold'>Company Parent</div><div className='card-text ml-30'>{company.TrendGroupName}</div></div></ListGroup.Item>
                  <ListGroup.Item><div className='text-row'><div className='card-bold'>Type of Account</div><div className='card-text ml-30'>{company.TypeOfAccountName}</div></div></ListGroup.Item>
                  <ListGroup.Item>
                    <div className='text-row'>
                      <div className='card-bold'>Phone</div>
                      <div className='card-text ml-30'>
                        <Telto phone={company.CompanyPhone}>{company.CompanyPhone}</Telto>
                      </div>
                    </div>
                  </ListGroup.Item>
                  <ListGroup.Item><div className='text-row'><div className='card-bold'>Address</div> <div className='card-text ml-30'>{company.CompanyAddress}, {company.CompanyCity}, {company.CompanyState}, {company.CompanyZip}</div></div></ListGroup.Item>
                  <ListGroup.Item><div className='text-row'><div className='card-bold'>Website</div> <div className='card-text ml-30'><a className='white-label-url' href={company.WhiteLabelUrl} target="_blank" rel='noreferrer'>{company.WhiteLabelUrl}</a></div></div></ListGroup.Item>
                </ListGroup>
              </div>
              <div className='card-item-2'>
                <ListGroup className="list-group-flush">
                  <ListGroup.Item><div className='text-row'><div className='card-bold'>Price Plan</div><div className='card-text ml-30'>{company.PricingPlanName}</div></div></ListGroup.Item>
                  <ListGroup.Item><div className='text-row'><div className='card-bold'>Ship Price Plan</div><div className='card-text ml-30'>{company.ShipPricingPlanName}</div></div></ListGroup.Item>
                </ListGroup>
                {company.IsAssociated ?
                  <ListGroup className="list-group-flush">
                    {company.ShowPricingSummary ? <ListGroup.Item><Button className="remove-filter-link" onClick={(e) => openReport(e, company, 1)}>Pricing Summary</Button></ListGroup.Item> : null}
                    {company.ShowPricingDetail ? <ListGroup.Item><Button className="remove-filter-link" onClick={(e) => openReport(e, company, 2)}>Detailed Pricing Sheet</Button></ListGroup.Item> : null}
                    {/* {company.ShowBuildAQuote ? <ListGroup.Item><Button className="remove-filter-link" onClick={(e) => openReport(e, company, 3)}>Build-a-Quote</Button></ListGroup.Item> : null} */}
                  </ListGroup>
                  : null}
              </div>
            </div>
          </Card.Body>
        </Accordion.Collapse>
      </Card>
    </Accordion>
    <TotalSpend showModal={showTotalSpendModal} closeModal={closeTotalSpend} totalSpends={totalSpend} helper={formatDollar}></TotalSpend>
    </>
  );
};